import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchReorderLevels'
})
export class SearchReorderLevelsPipe implements PipeTransform {

  transform(reorderLevels: any, searchText: string){

    if (!searchText) {
      return reorderLevels; // Return the original array if search text is empty
    }

    searchText = searchText.toLowerCase(); // Convert the search text to lowercase for case-insensitive comparison

    return reorderLevels.filter((reorderLevels: any) =>
      (reorderLevels.vehicle_make && reorderLevels.vehicle_make.toLowerCase().includes(searchText))||
      (reorderLevels.vehicle_model && reorderLevels.vehicle_model.toLowerCase().includes(searchText))||
      (reorderLevels.fuel_type && reorderLevels.fuel_type.toLowerCase().includes(searchText))
    );
  }

}
